/**
 * src/config/constants.jsx
 * Dynamic API base URL resolution:
 * Priority
 * 1) URL ?api_base=... (runtime override)
 * 2) window.API_BASE_URL (runtime)
 * 3) localStorage.API_BASE_URL (runtime)
 * 4) REACT_APP_API_URL (build-time)
 * 5) If hosted under *.findem.ai → production uses https://intakemate-api.findem.ai; otherwise same origin
 * 6) Fallback: http://localhost:3001
 */
function resolveApiBaseUrl() {
  // Runtime overrides via URL/local settings
  try {
    const w = typeof window !== 'undefined' ? window : null;
    if (w) {
      // URL query param ?api_base=https://intakemate.findem.ai:3001
      try {
        const qs = new URLSearchParams(w.location.search);
        const qsv = qs.get('api_base');
        if (qsv && qsv.startsWith('http')) return qsv;
      } catch {}

      // Global window var
      if (w.API_BASE_URL && typeof w.API_BASE_URL === 'string') {
        return w.API_BASE_URL;
      }

      // LocalStorage override
      if (w.localStorage) {
        const ls = w.localStorage.getItem('API_BASE_URL');
        if (ls && ls.startsWith('http')) return ls;
      }
    }
  } catch {}

  // Build-time override
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Smart default for *.findem.ai frontends:
  // - In production, use dedicated API host https://intakemate-api.findem.ai
  // - Otherwise, use same origin (include port if present)
  try {
    const w = typeof window !== 'undefined' ? window : null;
    if (w && /\.findem\.ai$/.test(w.location.hostname)) {
      const isProd = process.env.REACT_APP_MODE === 'production' || process.env.NODE_ENV === 'production';
      if (isProd) {
        return 'https://intakemate-api.findem.ai';
      }
      const proto = w.location.protocol; // http: or https:
      const host = w.location.hostname;  // e.g., intakemate.findem.ai
      if (host === 'intakemate.findem.ai') {
        host = 'intakemate-api.findem.ai'
      }
      const port = w.location.port ? `:${w.location.port}` : '';
      return `${proto}//${host}${port}`;
    }
  } catch {}

  // Local dev fallback
  return 'http://localhost:3001';
}

export const DEV_MODE = process.env.REACT_APP_MODE !== 'production';

export const API_CONFIG = {
  dev: 'http://localhost:3001',
  // Kept for reference; actual url chosen by resolveApiBaseUrl()
  prod: 'https://intakemate-api.findem.ai',
  url: resolveApiBaseUrl()
};
